import { Attachment } from './../shared-component/attachment-dialog/attachment.model';
import { Guid } from 'guid-typescript';
export class SessionUser {
    userName: string = '';
    firstName: string = '';
    expiryDate: string = '';
    token?: string;
    refreshToken?: string;
    userId?: Guid;
    services: SessionProfileService[] = [];
    profiles: SessionProfile[] = [];
    roles: SessionServiceRole[] = [];
    personPic?: Attachment;
    isRoot: boolean = false;
    isSuperAdmin: boolean = false;
    isAdmin: boolean = false;
    isDeveloper: boolean = false;
}

export class SessionProfile {
    profileId: Guid;
    serviceId: Guid;
    userKindId?: string;
    userKind?: string;
}

export class SessionServiceRole {
    id: Guid;
    serviceId: Guid;
    profileId?: Guid;
    name?: string;
}

export class SessionService {
    id: Guid;
    name?: string;
    customName?: string;
    code?: string;
    startDate: Date;
    endDate: Date;
    serviceKindId?: string;
    subscriptionId: Guid;
    isDelete: boolean;
    serviceTypeId?: string;
    roleId?: Guid;
}

export class SessionProfileService {
    profileId: Guid;
    service: SessionService;
}